module.exports = __webpack_public_path__ + "static/media/Buy_Ticket-2.db027ce2.jpg";